import {React,useState,useEffect} from 'react';
import ModalPopup from '../../common/ModalPopup/ModalPopup';
import {
  SUCCESS_POPUP_BUTTONS
} from "../../../helper/constants";
import './SuccessPopup.scss';
import { useTranslation } from "react-i18next";
import { Button_V2 } from '../../common/Button_V2';

const SuccessPopup = (props) => {
 const { t } = useTranslation();
const handleokChange = () => {
   props.closePopup();
  };
//SVG SUCCESSICON FUNCTION
const successIcon = () => {
  return(
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle opacity="0.18" cx="24" cy="24" r="24" fill="#5A8028"/>
    <g clip-path="url(#clip0_4617_37953)">
    <path d="M23.9993 37.3327C16.6353 37.3327 10.666 31.3633 10.666 23.9993C10.666 16.6353 16.6353 10.666 23.9993 10.666C31.3633 10.666 37.3327 16.6353 37.3327 23.9993C37.3327 31.3633 31.3633 37.3327 23.9993 37.3327ZM23.9993 34.666C26.8283 34.666 29.5414 33.5422 31.5418 31.5418C33.5422 29.5414 34.666 26.8283 34.666 23.9993C34.666 21.1704 33.5422 18.4573 31.5418 16.4569C29.5414 14.4565 26.8283 13.3327 23.9993 13.3327C21.1704 13.3327 18.4573 14.4565 16.4569 16.4569C14.4565 18.4573 13.3327 21.1704 13.3327 23.9993C13.3327 26.8283 14.4565 29.5414 16.4569 31.5418C18.4573 33.5422 21.1704 34.666 23.9993 34.666ZM22.67 29.3327L17.0127 23.6753L18.898 21.79L22.67 25.562L30.2113 18.0193L32.098 19.9047L22.67 29.3327Z" fill="#5A8028"/>
    </g>
    <defs>
    <clipPath id="clip0_4617_37953">
    <rect width="32" height="32" fill="white" transform="translate(8 8)"/>
    </clipPath>
    </defs>
    </svg>
  );
};
//SVG ERRORICON FUNCTION
const errorIcon = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle opacity="0.18" cx="24" cy="24" r="24" fill="#C2510A" />
      <g clip-path="url(#clip0_61872_138569)">
        <path d="M24.0001 37.3334C16.6361 37.3334 10.6667 31.364 10.6667 24C10.6667 16.636 16.6361 10.6667 24.0001 10.6667C31.3641 10.6667 37.3334 16.636 37.3334 24C37.3334 31.364 31.3641 37.3334 24.0001 37.3334ZM24.0001 34.6667C26.8291 34.6667 29.5422 33.5429 31.5426 31.5425C33.5429 29.5421 34.6667 26.829 34.6667 24C34.6667 21.171 33.5429 18.4579 31.5426 16.4575C29.5422 14.4572 26.8291 13.3334 24.0001 13.3334C21.1711 13.3334 18.458 14.4572 16.4576 16.4575C14.4572 18.4579 13.3334 21.171 13.3334 24C13.3334 26.829 14.4572 29.5421 16.4576 31.5425C18.458 33.5429 21.1711 34.6667 24.0001 34.6667ZM22.6667 28H25.3334V30.6667H22.6667V28ZM22.6667 17.3334H25.3334V25.3334H22.6667V17.3334Z" fill="#C2510A" />
      </g>
      <defs>
        <clipPath id="clip0_61872_138569">
          <rect width="32" height="32" fill="white" transform="translate(8 8)" />
        </clipPath>
      </defs>
    </svg>
  );
};

return (
  <ModalPopup
    showPopup={props?.show}
    size="lg"
    arialabel="Message Popup"
    centered="true"
    body={
      props.messageFlag ? (
        <>
          <div className="cls-iconContainer cls-iconContainer--row">
            <div className="cls-successIcon">{successIcon()}</div>
            <h3 className="cls-messageTitle cls-messageTitle--inline">
              {props.successMessage}
            </h3>
          </div>
        </>
      ) : (
        <>
          <div className="cls-iconContainer cls-iconContainer--row">
            <div className="cls-errorIcon">{errorIcon()}</div>
            <h3 className="cls-messageTitle cls-messageTitle--inline">
              {props.errorMessage}
            </h3>
          </div>
        </>
      )
    }
    footer={
      <div className="cls-messagePopup">
        <Button_V2
          type="primary"
          mode="default"
          size="medium"
          onClick={() => handleokChange()}
          className="ok-btn"
        >
          {t(SUCCESS_POPUP_BUTTONS.TITLE)}
        </Button_V2>
      </div>
    }
    cancelPopup={props?.closePopup}
  />
);
};
export default SuccessPopup;